import * as React from 'react';
import { TLCode } from '../../common/enums';
import { Icon, Menu } from 'antd';
import { TranslatedMessage } from '../common/translation';
import { Link } from 'react-router-dom';

export interface NavigationItemProps {
  page: string;
  icon: string;
  textTlCode: TLCode;
}

export class NavigationItem extends React.Component<NavigationItemProps> {
  render() {
    const { page, icon, textTlCode, ...restProps } = this.props;

    return (
      <Menu.Item {...restProps} key={page}>
        <Icon type={icon} />
        <span>
          <TranslatedMessage id={textTlCode} />
        </span>
        <Link to={page} />
      </Menu.Item>
    );
  }
}
